import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
// material
import { Container } from '@mui/material';
// redux
import { useDispatch, useSelector, RootState } from '../../../redux/store';
import { getUserList } from '../../../redux/slices/user';
// routes
import { Link as RouterLink, Navigate } from 'react-router-dom';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import useAuth from '../../../hooks/useAuth';
import { axios } from 'utils/axios';
import DriverCreateForm from 'components/_dashboard/driver/DriverForm';
// ----------------------------------------------------------------------

export default function DriverCreate() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { id = '' } = useParams();
  const [contactInfo, setContactInfo] = useState<any>({});

  const { userList } = useSelector((state: RootState) => state.user);
  const isEdit = pathname.includes('edit');
  const isDetails = pathname.includes('details');
  // const currentUser = userList.find((user) => paramCase(user.userID) === id);
  const [redirect, setRedirect] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    if (user?.role !== 'admin') {
      setRedirect(true);
    }
    if (!isEdit) {
      setContactInfo({});
    }
    fetchContactInfo();
  }, [isEdit]);

  const fetchContactInfo = async () => {
    const response = await axios.get(`/rest/api/drivers/${id}`);
    console.log(response.data.data);
    setContactInfo(response.data.data);
  };
  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);
  function redirectTo() {
    return <Navigate to="/dashboard/inspections" />;
  }

  if (redirect) return redirectTo();
  return (
    <Page title={`Driver: ${isEdit ? 'Edit' : isDetails ? 'Details' : 'Create'} a Driver`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={isDetails ? 'Driver Details' : isEdit ? 'Edit Driver' : 'Create a New Driver'}
          links={[
            { name: 'Dashboard', href: '/dashboard' },
            { name: 'Drivers', href: '/dashboard/drivers' },
            { name: isDetails ? 'Details' : isEdit ? 'Edit' : 'New Driver' }
          ]}
        />
        <DriverCreateForm isEdit={isEdit} isDetails={isDetails} currentUser={contactInfo} />
      </Container>
    </Page>
  );
}
